import Rest from '../rest'

/******************************************************************************
 *  UnitsReserves
 *****************************************************************************/

/**
 * @type {UnitsReserves}
 */
export default class UnitsReserves extends Rest {

    constructor () {
        super('/units/reserves')
    }

    getUnitsReservesDeal(deal_id) {
        return this.http2.get(`${this.resource}/deal/${deal_id}`)
    }
}